export const sendErrorMessage = () => {
    window.parent.postMessage({
        source: 'cbar-login',
        message: 'error',
        error: "User is not logged in",
    }, '*');
};
export const sendSuccessMessage = (redirectUrl) => {
    window.parent.postMessage({
        source: 'cbar-login',
        message: 'success',
        redirectUrl,
    }, '*');
};
